import React from 'react';
import * as styles from './accordeon.module.sass';
import { useState } from 'react';
import classNames from 'classnames';

export const Accordeon = (props: any) => {
  const [isOpen, setOpen] = useState(true);

  return (
    <>
      <div className={styles.faq_accordeon} onClick={() => setOpen(!isOpen)}>
        <p className={styles.title}>
          {props.title}
        </p>
        <div className={classNames(styles.circle_plus, !isOpen && styles.active)}></div>
      </div>
      <div className={classNames(styles.accordeon_answers, isOpen && styles.collapsed)}>
        <div className={styles.accordion_content}>{props.description}</div>
      </div>
    </>
  );
};
